var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1Idea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69 38v4H59v-4h10zM58.67 16.45l-7.07 7.07 2.83 2.83 7.07-7.08-2.83-2.82zm-5.09 23.62A15.92 15.92 0 0146 53.61v7.46a8 8 0 01-16 0V54a15.91 15.91 0 1123.58-13.93zm-4 0A11.92 11.92 0 1034 51.4v8.68h8v-8.92a11.94 11.94 0 007.58-11.09zM40 9.07h-4v10h4v-10zm-23.35 7.38l-2.82 2.82 7.07 7.08 2.83-2.83-7.08-7.07zM7 42h10v-4H7v4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_Idea.ee2674e8.svg";
export { SvgK1Idea as ReactComponent };